import Select, { SelectOption } from 'corp/components/UI/Select';
import { WorkerSkillDimensionQualityCategory } from '@scale/shared-types';

type Props = {
  onChange: (category: WorkerSkillDimensionQualityCategory | undefined) => void;
  value: WorkerSkillDimensionQualityCategory | undefined;
  className?: string;
  disabled?: boolean;
};

const SelectWorkerSkillCategory = ({ onChange, value, className, ...props }: Props) => {
  return (
    <Select
      className={className}
      onChange={(value: SelectOption | null) => {
        if (value?.value) {
          onChange(value.value as WorkerSkillDimensionQualityCategory);
        }
      }}
      value={value}
      options={Object.values(WorkerSkillDimensionQualityCategory).map(category => ({
        label: category,
        value: category,
      }))}
      placeholder="Select category"
      {...props}
    />
  );
};

export default SelectWorkerSkillCategory;
